import { render, staticRenderFns } from "./project.vue?vue&type=template&id=0ec2eaf8&scoped=true&"
import script from "./project.vue?vue&type=script&lang=js&"
export * from "./project.vue?vue&type=script&lang=js&"
import style0 from "./project.vue?vue&type=style&index=0&id=0ec2eaf8&lang=scss&scoped=true&"
import style1 from "./project.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec2eaf8",
  null
  
)

export default component.exports